import array from "./Array";
import number from "./Number";
import date from "./Date";
import math from "./Math";

for (const arrayKey in array) {
  Object.defineProperty(Array.prototype, arrayKey, {
    enumerable: false,
    value: array[arrayKey],
  });
}
for (const numberKey in number) {
  Object.defineProperty(Number.prototype, numberKey, {
    enumerable: false,
    value: number[numberKey],
  });
}
for (const dateKey in date) {
  Object.defineProperty(Date.prototype, dateKey, {
    enumerable: false,
    value: date[dateKey],
  });
}

for (const mathKey in math) {
  Object.defineProperty(Math, mathKey, {
    enumerable: false,
    value: math[mathKey],
  });
}




// WEBPACK FOOTER //
// ./src/utils/extensions/index.js